module.exports = __webpack_public_path__ + "static/media/picnic.e2e4fe56.jpg";